export const getGoogleMapsLink = (street: string) => {
    return "https://www.google.com/maps/search/?api=1&query=" + street;
}